import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./RightsManagement.css";

const WhyFtTune = ({ headingbefore, mark, headingafter, detail, detail2, imageurl }) => {
  return (
    <div className="rm-why">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="mb-5 mb-lg-0 text-center">
            <motion.img
              src={`/${imageurl}`}
              alt="Why FT Tunes"
              className="img-fluid"
              style={{ maxWidth: "100%", height: "auto" }}
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            />
          </Col>
          <Col lg={1} />
          <Col lg={6}>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="mini-title">WHY FT TUNES</div>
              <h2>
                {headingbefore} <span className="text-gradient-orange">{mark}</span> {headingafter}
              </h2>
              <div style={{ width: "50px", height: "2px", background: "linear-gradient(90deg, #b042ff, #f97316)", marginBottom: "30px" }}></div>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                {detail}
              </p>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6" }}>
                {detail2}
              </p>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6", marginTop: "30px" }}>
                Let FTunes manage your music rights, so you can focus on creating music that moves the world.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhyFtTune;
